export const bot = (
  <g transform="scale(0.8) translate(2, 1)">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.4887 2.75573H25.8618L22.4172 6.22541V7.41637L25.8618 10.8861H30.4887V12.9186H25.0263L20.9906 8.85347H6.22504L15.0887 27.1467H24.2144L26.2323 29.1793V33.2444L24.2144 35.277H2.01787L0 33.2444V29.1793L2.01787 27.1467H10.5997L0.638466 6.58865L4.25644 4.81014V4.78831H20.9906L25.0263 0.723145H30.4887V2.75573ZM2.01787 30.0209V32.4028L2.85339 33.2444H23.3789L24.2144 32.4028V30.0209L23.3789 29.1793H2.85339L2.01787 30.0209Z"
      fill="currentColor"
    />
  </g>
);
